import { LocationQueryEnum, ILocationQueryLabel } from "redmond";
import { delay, put } from "redux-saga/effects";
import { actions } from "../actions";
import { fetchHotelAutocomplete } from "../../../api/v0/search/fetchHotelAutocomplete";

export function* fetchDestinationCategories(
  action: actions.IFetchDestinationCategories
) {
  yield delay(300);
  try {
    const requestBody: ILocationQueryLabel = {
      LocationQuery: LocationQueryEnum.Label,
      l: action.queryString,
    };
    const { categories } = yield fetchHotelAutocomplete(requestBody);

    yield put(actions.setDestinationCategories(categories));
  } catch (e) {
    yield put(actions.setDestinationCategories([]));
    yield put(actions.setDestinationAutocompleteError(true));
  }
}
